import { render, staticRenderFns } from "./successNew.vue?vue&type=template&id=2233c45c&scoped=true"
import script from "./successNew.vue?vue&type=script&lang=js"
export * from "./successNew.vue?vue&type=script&lang=js"
import style0 from "./successNew.vue?vue&type=style&index=0&id=2233c45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233c45c",
  null
  
)

export default component.exports